import { create } from "zustand";
import { jwtDecode } from "jwt-decode";
import { login as apiLogin } from "../api/services";

function readToken() {
  const token = localStorage.getItem("Authorization");
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp * 1000 < Date.now()) {
      localStorage.removeItem("Authorization");
      return null;
    }
    return { token, username: decoded.username, role: decoded.role };
  } catch {
    localStorage.removeItem("Authorization");
    return null;
  }
}

export const useAuthStore = create((set) => ({
  user: readToken(),
  error: null,
  async login(username, password) {
    try {
      const data = await apiLogin(username, password);
      localStorage.setItem("Authorization", data.token);
      set({ user: { token: data.token, username: data.username, role: data.role }, error: null });
      return true;
    } catch (e) {
      set({ error: "Неверное имя или пароль" });
      return false;
    }
  },
  logout() {
    localStorage.removeItem("Authorization");
    set({ user: null });
  },
}));
